export default {
  rules: {
    required: '此字段必须填写',
    email: '请输入有效的电子邮件地址',
    url: '请输入有效的网址',
    alpha: '只能包含字母',
    alphaNum: '只能包含字母和数字',
    numeric: '只能包含数字',
    min: '不能小于 {min}',
    max: '不能大于 {max}',
    minLength: '长度不能少于 {min} 个字符',
    maxLength: '长度不能超过 {max} 个字符',
    between: '必须介于 {min} 和 {max} 之间',
    confirmed: '输入不匹配',
    date: '请输入有效的日期',
    dateFormat: '日期必须为 {format} 格式',
    dateAfter: '日期必须晚于 {date}',
    dateBefore: '日期必须早于 {date}'
  },
  fields: {
    name: '名称',
    email: '电子邮件',
    password: '密码',
    confirmPassword: '确认密码',
    message: '消息',
    phone: '电话号码',
    subject: '主题',
    comments: '评论',
    feedback: '反馈'
  }
}; 